import { CloudUploadIcon, IconButton, type IconButtonSize } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import { uploadWindows } from "@/page/upload/uploadWindow";
import type { EmptyStateAction } from "@/shared/ui/emptyState/public";

const UPLOAD_LABEL = "Dataset 업로드";

export type DatasetUploadButtonProps = {
  size?: IconButtonSize;
  // 업로드 창이 닫히면(완료, 폐기) 1회 호출한다. 목록 새로고침 같은 정리에 쓴다.
  onClosed?: () => void;
};

/**
 * 공용 Dataset 업로드 진입 버튼.
 *
 * 데이터셋 목록 툴바와 업로드 현황 툴바가 이 버튼을 쓴다. 그래서 두 툴바는 같은 라벨로
 * 같은 업로드 창(uploadWindows)을 연다.
 * 창의 동시 상한과 재개/재시도 seed 는 uploadWindows 가 소유한다.
 */
export function DatasetUploadButton({ onClosed, size }: DatasetUploadButtonProps): ReactNode {
  return (
    <IconButton
      text={UPLOAD_LABEL}
      size={size}
      type="button"
      variant="solid"
      title="새 Dataset을 업로드합니다."
      onClick={() => uploadWindows.open({ onClose: onClosed })}
    >
      <CloudUploadIcon />
    </IconButton>
  );
}

/** 빈 Dataset 목록 안내의 동작. 헤더 버튼과 같은 라벨로 같은 업로드 창을 연다. */
export function datasetUploadAction(onClosed?: () => void): EmptyStateAction {
  return {
    label: UPLOAD_LABEL,
    icon: <CloudUploadIcon />,
    variant: "solid",
    onClick: () => uploadWindows.open({ onClose: onClosed }),
  };
}
